export const getGroupSelected = (state) => state.bufferState.groupSelected;

export const getFilterActive = (state) => state.bufferState.filterActive;

export const getTrackerSelected = (state) => state.alertState.trackerSelected;
